export const buildCategoryObject = (category) => {
  return {
    houseCategory: category.houseCategory,
    name: category.name,
    paymentCategory: category.paymentCategory,
    voucherCategory: category.voucherCategory,
    tier: category.tier
  };
};
